import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from '@material-ui/core';
import { Flex, ListItem, Switch } from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection, TabSectionHeader } from '../../TabSections';
import { PreferredProperties } from './PreferredProperties';
import ReferralRadius from './ReferralRadius';
import ReferralSource from './ReferralSource';
import { useCrossSell } from './use-cross-sell';
import { crossSellPropTypes } from '../../../../prop-types';
import { SECTIONS } from '../../constants';
import { CROSS_SELL_FIELDS } from '../constants';

const {
  CROSS_SELL_RADIUS,
  CROSS_SELL_REFERRAL_SOURCE,
  NEARBY_PROPERTIES_EXCLUDED_PROPERTIES,
} = CROSS_SELL_FIELDS;

const { DESCRIPTION, TITLE } = SECTIONS.CROSS_SELL;

const REFERRAL_SOURCE_DESCRIPTION =
  'Select a custom referral source for prospects that are referred to another property.';

const CrossSell = ({ crossSell = {}, updateCrossSell }) => {
  const {
    [CROSS_SELL_RADIUS]: radius,
    [CROSS_SELL_REFERRAL_SOURCE]: referralSource,
    [NEARBY_PROPERTIES_EXCLUDED_PROPERTIES]: excludedProperties,
    properties = [],
    referralSourceOptions,
  } = crossSell;

  const {
    excludedPropertiesMap,
    handleUpdateCrossSell,
    handleUpdateCrossSellRadius,
    propertyDataRows,
    setExcludedPropertiesMap,
  } = useCrossSell({ excludedProperties, properties, radius, updateCrossSell });

  const sliderDistanceUnit = propertyDataRows[0]?.unit;

  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      <Flex flexDirection="column" gap={16}>
        <ListItem
          component="div"
          disableGutters
          endSlot={
            <Switch
              checked={true}
              id="enable-auto-referrals"
              onChange={() => {}}
              aria-label="enable auto-referrals"
            />
          }
          startSlot={
            <TabSectionHeader
              description="Automatically refer prospects to nearby properties."
              title="Enable Auto-Referrals"
            />
          }
        />
        <Collapse in={true} mountOnEnter unmountOnExit>
          <Flex flexDirection="column" gap={16}>
            <ReferralRadius
              key={radius}
              propertyCount={propertyDataRows.length}
              radius={radius}
              setRadius={handleUpdateCrossSellRadius}
              sliderDistanceUnit={sliderDistanceUnit}
            />

            <PreferredProperties
              key={`${NEARBY_PROPERTIES_EXCLUDED_PROPERTIES}-${radius}`}
              propertyDataRows={propertyDataRows}
              updateCrossSell={handleUpdateCrossSell(
                NEARBY_PROPERTIES_EXCLUDED_PROPERTIES,
              )}
              excludedPropertiesMap={excludedPropertiesMap}
              setExcludedPropertiesMap={setExcludedPropertiesMap}
            />

            <ListItem
              component="div"
              disableGutters
              startSlot={
                <TabSectionHeader
                  description={REFERRAL_SOURCE_DESCRIPTION}
                  title="Referral Source"
                />
              }
            />

            <ReferralSource
              referralSource={referralSource}
              referralSourceOptions={referralSourceOptions}
              updateCrossSell={handleUpdateCrossSell(
                CROSS_SELL_REFERRAL_SOURCE,
              )}
            />
          </Flex>
        </Collapse>
      </Flex>
    </DividedTabSection>
  );
};

CrossSell.propTypes = {
  crossSell: crossSellPropTypes,
  updateCrossSell: PropTypes.func,
};

export default CrossSell;
